// src/firebase/config.js

import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAmHRj7_OVCOHEpbpsHL4W3lC5nwdh_0SQ",
  authDomain: "steps4inclusiveai.firebaseapp.com",
  projectId: "steps4inclusiveai",
  storageBucket: "steps4inclusiveai.firebasestorage.app",
  messagingSenderId: "820912221586",
  appId: "1:820912221586:web:4845425006ca345e7b254b",
  measurementId: "G-MLN28RJCKR"
};

// Initialize Firebase
// This conditional check prevents the "duplicate app" error
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

export { db };